<template>
  <div>
    <!-- <a-form ref="userForm" :model="userMod" :rules="rules">
      <a-form-item label="用户名" name="userName">
        <a-input v-model:value="userMod.userName" placeholder="用户名" />
      </a-form-item>
      <a-form-item label="手机号" name="userPhone">
        <a-input v-model:value="userMod.userPhone" placeholder="手机号" />
      </a-form-item>
      <a-form-item>
        <a-button style="margin-right: 10px" size="small" @click="CancleEdit"
          >取消</a-button
        >
        <a-button type="primary" size="small" @click="EditUserComHandle"
          >确定</a-button
        >
      </a-form-item>
    </a-form> -->
    <el-form
      ref="UserFrom"
      :model="userMod"
      label-position="top"
      label-width="130px"
      size="mini"
      :rules="rules"
    >
      <el-form-item label="用户名" prop="userName">
        <el-input v-model="userMod.userName"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="userPhone">
        <el-input v-model="userMod.userPhone"></el-input>
      </el-form-item>
      <el-form-item label="角色" prop="userRoleId">
        <el-select v-model="userMod.userRoleId" placeholder="请选择">
          <el-option
            v-for="item in roleSelList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="密码" prop="password" v-if="userMod.id == ''">
        <el-input v-model="userMod.password"></el-input>
      </el-form-item>
      <el-form-item label="重复密码" prop="repassword" v-if="userMod.id == ''">
        <el-input v-model="userMod.repassword"></el-input>
      </el-form-item>

      <el-form-item label="">
        <el-button type="primary" @click="EditUserComHandle('UserFrom')"
          >确定</el-button
        >
        <el-button @click="CancleEdit">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { userEdit, getUserRoleSelList } from "@/api/user";
export default {
  props: {
    userMod: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    var validaterePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.userMod.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      rules: {
        userName: [
          { required: true, message: "请输入用户名", trigger: "change" },
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        userPhone: [
          { required: true, message: "请输入手机号", trigger: "change" },
          { required: true, message: "请输入手机号", trigger: "blur" },
        ],
        userRoleId: [
          { required: true, message: "请选择用户角色", trigger: "change" },
          { required: true, message: "请选择用户角色", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "change" },
          { required: true, message: "请输入密码", trigger: "blur" },
        ],
        repassword: [
          { required: true, message: "请重复密码", trigger: "change" },
          { required: true, message: "请重复密码", trigger: "blur" },
          { validator: validaterePass, trigger: "change" },
          { validator: validaterePass, trigger: "blur" },
        ],
      },
      roleSelList: [],
    };
  },

  created() {
    getUserRoleSelList().then((res) => {
      if (res.code == 0) {
        this.roleSelList = res.data;
      } else {
        this.$message.error(res.msg);
      }
    });
  },
  methods: {
    EditUserComHandle(formName) {
      if (this.userMod.id != "") {
        (this.userMod.password = "0"), (this.userMod.repassword = "0");
      }
      this.$refs[formName].validate().then((valid) => {
        if (valid) {
          userEdit(
            this.userMod.id,
            this.userMod.userName,
            this.userMod.userPhone,
            this.userMod.password,
            this.userMod.repassword,
            this.userMod.userRoleId
          ).then((res) => {
            if (res.code == 0) {
              this.$message.success(res.msg);
              this.$emit("EditUserComHandle", this.userMod);
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
    CancleEdit() {
      this.$emit("CancleEdit");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>